import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const exportTransactionsToExcel = (transactions, fileName = "Transactions.xlsx") => {
    const data = transactions.map((tx) => {
        const shareAmount = tx.quantity * tx.rate;

        const commission =
            tx.transactionType === "BUY"
                ? tx.amount - shareAmount
                : shareAmount - tx.amount;

        const rateWithCommission = tx.amount / tx.quantity;

        return {
            ID: tx.id,
            Date: tx.date,
            Scrip: tx.scrip,
            Type: tx.transactionType,
            Quantity: tx.quantity,
            Rate: tx.rate,
            Amount: tx.amount,
            "Share Amount": shareAmount.toFixed(2),
            Commission: commission.toFixed(2),
            "C.Rate": rateWithCommission.toFixed(2),
            Partner: tx.partner || "Personal",
        };
    });

    const worksheet = XLSX.utils.json_to_sheet(data);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Transactions");

    const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
    });

    const file = new Blob([excelBuffer], {
        type: "application/octet-stream",
    });

    saveAs(file, fileName);
};